<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="10" md="8">
        <v-text-field
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="entry.groupId"
          v-bind="getObject('groupId')"
          label="Grupo"
          :items="extraData.accountGlobalSharedContext.allGroupsForOthers"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <GroupNew
              :inlineAddButton="true"
              @entry-created="groupCreated"
              withType="other"
              modelNameSingular="Grupo de Item"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="5">
        <v-autocomplete
          v-model="entry.brandId"
          v-bind="getObject('brandId')"
          label="Marca"
          :items="extraData.accountGlobalSharedContext.allBrandsOfItems"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <BrandNew
              :inlineAddButton="true"
              @entry-created="brandCreated"
              withType="item"
              modelNameSingular="Marca de Item"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="entry.unitId"
          v-bind="getObject('unitId')"
          label="Unidade de Consumo"
          :items="extraData.globalContext.allUnits"
          item-value="id"
          item-text="name"
          @input="getPackagingsForUnit(true)"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="entry.barcode"
          v-bind="getObject('barcode')"
          label="Código de Barra"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>


      <v-col cols="12" class=""> 
        <MultiSelect
          v-model="entry.packagingIds"
          v-bind="getObject('packagingIds')"
          label="Embalagens"
          :items="packagingsList"
          :loadingItems="packagingsListLoading"
          :readOnly="entry.unitId ? readOnly : true"
          :key="packagingsListKey"
        >
           <template v-slot:new_action>
            <PackagingNew
              :inlineAddButton="true"
              @entry-created="packagingCreated"
              modelNameSingular="Embalagem"
            />
          </template>
        </MultiSelect>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import MultiSelect from "@shared_components/multi_select.vue";
import gql from 'graphql-tag'
import GroupNew from "@models/groups/new.vue"
import BrandNew from "@models/brands/new.vue"
import PackagingNew from "@models/packagings/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    MultiSelect: MultiSelect,
    GroupNew: GroupNew,
    BrandNew: BrandNew,
    BaseUtil: BaseUtil,
    PackagingNew: PackagingNew
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
    if (this.entry.unitId) {
      this.getPackagingsForUnit(false);
    }
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },  
    getPackagingsForUnit: function(hasChanged) {
      if (hasChanged) {
        this.entry.packagingIds = [];
      }
      this.packagingsListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_PACKAGING_BY_UNIT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            unitId: this.entry.unitId
          }
        })
        .then(response => {
          // console.log("cities", response.data, this.entry);
          this.packagingsList = response.data.accountGlobalSharedContext.availablePackagingsByUnit;
          this.packagingsListKey++;
          // if (this.entry.unit) {
          //   this.entry.unitId = this.entry.unit.id;
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingsListLoading = false));
    },
    groupCreated: function(group) {
      if (group.groupType == "other") {
        this.extraData.accountGlobalSharedContext.allGroupsForOthers.unshift(group);
        this.entry.groupId = group.id;
        this.entry.group = group;
      } else {
        this.$refs.util.showErrorMessage("O Grupo cadastrado não é do tipo Itens Diversos, por isso não irá aparecer na lista de grupos!");
      }
    },
    brandCreated: function(brand) {
      if (brand.brandType == "item") {
        this.extraData.accountGlobalSharedContext.allBrandsOfItems.unshift(brand);
        this.entry.brandId = brand.id;
        this.entry.brand = brand;
      } else {
        this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      }
    },
    packagingCreated: function(packaging) {
      // if (brand.brandType == "item") {
      this.packagingsList.unshift(packaging);
      this.entry.packagingIds.push(packaging.id);
      // this.entry.brand = brand;
      // } else {
      //   this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      // }
    },
  }
};
const AVAILABLE_PACKAGING_BY_UNIT_QUERY = gql `
  query ($unitId: ID!) {
    accountGlobalSharedContext {
      availablePackagingsByUnit(unitId: $unitId) {
        id
        name
      }
    }
  }
`;
</script>

<style scoped></style>
